import React, { Component } from "react";
import Header from "./includes/Header";
import Sidebar from "./includes/Sidebar";
import Footer from "./includes/Footer";
import URLs from "./utils/apis";
import axios from "axios";
import { Table, Spin, message } from "antd";
import FullEditor from "ckeditor5-build-full";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import moment from "moment";
import CopyRight from "./includes/CopyRight";

export default class AddPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total_users: 0,
      loading: false,

      title: "",
      author_name: "",
      date: moment().format("YYYY-MM-DD"),
      short_description: "",
      long_description: "",
      banner_img: "",
    };
  }
  componentDidMount() {}
  save_post = () => {
    if (!this.state.title) {
      message.warning("Title is required.");
      return;
    }
    if (!this.state.author_name) {
      message.warning("Author name is required.");
      return;
    }
    if (!this.state.date) {
      message.warning("Date is required.");
      return;
    }
    // if (!this.state.short_description) {
    //   message.warning("Short description is required.");
    //   return;
    // }
    if (!this.state.long_description) {
      message.warning("Description is required.");
      return;
    }
    if (!this.state.banner_img) {
      message.warning("Please select Banner image");
      return;
    }
    this.setState({ loading: true });
    let formData = new FormData();
    formData.append("title", this.state.title);
    formData.append("author_name", this.state.author_name);
    formData.append("date", moment(this.state.date).format("YYYY-MM-DD"));
    formData.append("short_description", this.state.short_description);
    formData.append(
      "long_description",
      JSON.stringify(this.state.long_description)
    );
    formData.append("banner_img", this.state.banner_img);
    axios
      .post(URLs.save_blog_post, formData)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          );
        } else {
          message.warning(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error("Warning:", error);
      });
  };
  render() {
    return (
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        <div class="main-content">
          <div class="page-content">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <a
                    href="/blog-posts"
                    class="btn btn-dark mb-3"
                    style={{
                      width: 100,
                      marginLeft: "auto",
                      marginRight: 20,
                    }}
                  >
                    Back
                  </a>
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Add New Post</h4>
                    <div class="page-title-right"></div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <Spin spinning={this.state.loading}>
                      <div class="card-header row px-0">
                        <div className="col-lg-8">
                          <div className="mb-4 form-group">
                            <label>
                              Title <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              placeholder="Title"
                              value={this.state.title}
                              onChange={(e) =>
                                this.setState({ title: e.target.value })
                              }
                            />
                          </div>
                          <div className="mb-4 form-group">
                            <label>
                              Author Name <span className="text-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              placeholder="Author Name"
                              value={this.state.author_name}
                              onChange={(e) =>
                                this.setState({ author_name: e.target.value })
                              }
                            />
                          </div>
                          <div className="mb-4 form-group">
                            <label>
                              Date <span className="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={this.state.date}
                              onChange={(e) =>
                                this.setState({ date: e.target.value })
                              }
                            />
                          </div>
                          {/* <div className="mb-4 form-group">
                            <label>
                              Short Description{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              name="txtname"
                              rows="4"
                              cols="50"
                              value={this.state.short_description}
                              onChange={(e) =>
                                this.setState({
                                  short_description: e.target.value,
                                })
                              }
                            ></textarea>
                          </div> */}
                          <div className="mb-4 form-group">
                            <label>
                              Description <span className="text-danger">*</span>
                            </label>
                            <CKEditor
                              data={this.state.long_description}
                              editor={FullEditor}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                this.setState({ long_description: data });
                              }}
                            />
                          </div>
                          <div className="mb-4 form-group">
                            <label>
                              Banner <span className="text-danger">*</span>
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) =>
                                this.setState({ banner_img: e.target.files[0] })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-4"></div>
                        <div className="col-lg-4">
                          <a
                            href="/blog-posts"
                            class="btn btn-dark mb-3"
                            style={{
                              width: 100,
                              marginLeft: "auto",
                              marginRight: 20,
                            }}
                          >
                            Back
                          </a>
                          <button
                            type="button"
                            class="btn btn-primary mb-3"
                            style={{
                              width: 100,
                              marginLeft: "auto",
                            }}
                            onClick={() => this.save_post()}
                          >
                            Save Post
                          </button>
                        </div>
                      </div>
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CopyRight />
        </div>
      </div>
    );
  }
}
